import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import MainLayout from "@/components/layout/MainLayout";

// modules
import A01 from "./modules/A/A01";
import A02 from "./modules/A/A02";
import A03 from "./modules/A/A03";
import A04 from "./modules/A/A04";
import A05 from "./modules/A/A05";
import A07 from "./modules/A/A07";

import B01 from "./modules/B/B01";
import B02 from "./modules/B/B02";
import B03 from "./modules/B/B03";
import B04 from "./modules/B/B04";
import B05 from "./modules/B/B05";
import B06 from "./modules/B/B06";

import C01 from "./modules/C/C01";
import C02 from "./modules/C/C02";

import D01 from "./modules/D/D01";

import E01 from "./modules/E/E01";
import E02 from "./modules/E/E02";

// lazy pages
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const Dashboard = lazy(() => import("@/pages/Dashboard/Dashboard"));
const RefusePage = lazy(() => import("@/pages/RefusePage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const PrintHistoryPage = lazy(() => import("@/pages/PrintHistoryPage"));

const PrivateRoute = ({ children, ...rest }) => {
  const token = sessionStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={() => (token ? children : <Redirect to="/login" />)}
    />
  );
};

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Switch>
        {/* 로그인 */}
        <Route path="/login" component={LoginPage} />

        <Route path="/privacy" component={PrivacyPage} />


        {/* 예외 페이지 */}
        <Route exact path="/multiIp">
          <RefusePage message="동일한 아이디로 이미 로그인 되어 있습니다." />
        </Route>

        <Route exact path="/unauthorized">
          <RefusePage message="유효하지 않은 인증입니다." />
        </Route>

        {/* 빈 페이지 */}
        <Route exact path="/test" component={() => null} />


        {/* 인증 영역 */}
        <PrivateRoute path="/">
          <MainLayout currPath={window.location.pathname}>
            <Switch>


              {/* 대시보드 */}
              <Route exact path="/" component={Dashboard} />
              <Route exact path="/print-history" component={PrintHistoryPage} />

              {/* 모듈 라우터는 반드시 Route로 감싼다 */}
              <Route path="/A01" component={A01} />
              <Route path="/A02" component={A02} />
              <Route path="/A03" component={A03} />
              <Route path="/A04" component={A04} />
              <Route path="/A05" component={A05} />
              <Route path="/A07" component={A07} />

              <Route path="/B01" component={B01} />
              <Route path="/B02" component={B02} />
              <Route path="/B03" component={B03} />
              <Route path="/B04" component={B04} />
              <Route path="/B05" component={B05} />
              <Route path="/B06" component={B06} />

              <Route path="/C01" component={C01} />
              <Route path="/C02" component={C02} />

              <Route path="/D01" component={D01} />

              <Route path="/E01" component={E01} />
              <Route path="/E02" component={E02} />

              {/* 404 */}
              <Route path="*" component={NotFoundPage} />
            </Switch>
          </MainLayout>
        </PrivateRoute>
      </Switch>
    </Suspense>
  );
};

export default Router;
